import { css } from 'lit';

/** Card-sized type for a rendered brief, on an element with class brief-md. */
export const BRIEF_STYLES = css`
    .brief-md h1, .brief-md h2, .brief-md h3 {
        font-size: 0.95rem; font-weight: 600; margin: 0.75rem 0 0.25rem;
    }
    .brief-md h4, .brief-md h5, .brief-md h6 {
        font-size: inherit; font-weight: 600; margin: 0.5rem 0 0.25rem;
    }
    .brief-md > :first-child { margin-top: 0; }
    .brief-md p, .brief-md ul, .brief-md ol, .brief-md pre, .brief-md blockquote { margin: 0 0 0.5rem; }
    .brief-md > :last-child { margin-bottom: 0; }
    .brief-md ul, .brief-md ol { padding-left: 1.25rem; }
    .brief-md li > p { margin: 0; }
    .brief-md code { font-size: 0.85em; }
    .brief-md pre { white-space: pre-wrap; }
    .brief-md blockquote { padding-left: 0.75rem; border-left: 3px solid #dee2e6; color: #555; }
`;
